function initShadesSplides() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.splide[id^="shades-splide-"]');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;
    el.classList.add('is-initialized');

    var sectionWrapper = el.closest('.section-shades');
    var count = el.querySelectorAll('.splide__slide').length;
    var perPageDesktop = Math.min(count, 3);

    var slider = new Splide(el, {
      type: 'slide',
      perPage: perPageDesktop,
      perMove: 1,
      gap: '16px',
      pagination: false,
      arrows: false,
      drag: true,
      breakpoints: {
        991: {
          perPage: 1,
          perMove: 1,
          gap: '10px',
          fixedWidth: 'calc((100% + 10px)/1.33 - 10px)',
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var prevBtns = sectionWrapper ? sectionWrapper.querySelectorAll('.js-shades-prev, .js-shades-prev-mobile') : [];
    var nextBtns = sectionWrapper ? sectionWrapper.querySelectorAll('.js-shades-next, .js-shades-next-mobile') : [];
    var bar = el.querySelector('.js-shades-progress-bar');

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        slider.go('<');
      });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        slider.go('>');
      });
    });

    function setButtonDisabled(btn, isDisabled) {
      btn.classList.toggle('is-disabled', isDisabled);
      btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    }

    function syncShadesControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;
      var index = Math.min(Math.max(slider.index, 0), end);

      if (bar) {
        var rate = Math.min((index + 1) / (end + 1), 1);
        bar.style.width = String(100 * rate) + '%';
      }
      prevBtns.forEach(function (btn) {
        setButtonDisabled(btn, index <= 0);
      });
      nextBtns.forEach(function (btn) {
        setButtonDisabled(btn, index >= end);
      });
    }

    slider.on('mounted move moved updated refresh resized scrolled', syncShadesControls);
    slider.mount();
  });
}

document.addEventListener('DOMContentLoaded', initShadesSplides);
window.addEventListener('load', initShadesSplides);

document.addEventListener('shopify:section:load', function (e) {
  if (e.target && e.target.querySelector('.section-shades')) {
    initShadesSplides();
  }
});

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.section-shades') || node.querySelector('.section-shades')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initShadesSplides();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
